import React, { Fragment } from 'react';
import $S from 'theme/settings';
import { Redirect } from 'react-router-dom';
import { hasPermission } from '../../utils/permission';

class Permission extends React.Component {
  has() {
    const { permissions = [], route = '' } = this.props;
    // Admin ve Super user kontrolü yapmamız istenmiyor şimdilik.
    // const isSuperUser = isExecutive(permissions, $P.IS_SUPER_USER);
    // const isAdmin = isExecutive(permissions, $P.IS_ADMIN);

    // if (isAdmin || isSuperUser) {
    //   return true;
    // }

    return hasPermission(permissions, route);
  }

  render() {
    const { alternate = null, redirect, children } = this.props;
    const isAccessible = !$S.hasPermissionForPages || this.has();

    if (!isAccessible && redirect) {
      return <Redirect to={redirect} />;
    }

    return <Fragment>{isAccessible ? children : alternate}</Fragment>;
  }
}

export default Permission;



// WEBPACK FOOTER //
// ./src/components/partials/Permission.js